import { render, staticRenderFns } from "./StadiumFields.vue?vue&type=template&id=fb350980&"
import script from "./StadiumFields.vue?vue&type=script&lang=js&"
export * from "./StadiumFields.vue?vue&type=script&lang=js&"
import style0 from "./StadiumFields.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports